import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import themeable from 'zignal-landscape/lib/themeable';
import Input from 'zignal-landscape/lib/Input';
import Save1Icon from 'zignal-landscape/lib/Icon/Save1Icon';
import Remove1Icon from 'zignal-landscape/lib/Icon/Remove1Icon';


class ZccForm extends Component {

  renderInput(props) {
    const nameError = (props.errors && props.errors.validationErrors) ? props.errors.validationErrors.name[0] : null;
    return (
      <Input
        {...props.input}
        error={nameError}
        className={props.styles.name}
        placeholder="Command Center Name"
      />
    );
  }

  render() {
    const {styles, handleSubmit, onCancel} = this.props;

    return (
      <form onSubmit={handleSubmit} className={styles.ZccForm}>
        <Field component="input" type="hidden" name="_id" />
        <Field component="input" type="hidden" name="accountId" />
        <div className={styles.fields}>
          <Field {...this.props} name="name" component={this.renderInput} />
        </div>
        <span className={styles.menu}>
          <a onClick={handleSubmit} className={styles.save}><Save1Icon /></a>
          <a onClick={onCancel} className={styles.cancel}><Remove1Icon /></a>
        </span>
      </form>
    );
  }

}


ZccForm.propTypes = {
  styles: PropTypes.object,
  handleSubmit: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  errors: PropTypes.object
};

export const _ZccForm = themeable(ZccForm);

export default reduxForm({
  form: 'simple' // a unique identifier for this form
})(themeable(ZccForm));
